import { render, staticRenderFns } from "./batchRechargeLog.vue?vue&type=template&id=32ab4d63&"
import script from "./batchRechargeLog.vue?vue&type=script&lang=js&"
export * from "./batchRechargeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports